import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Blue Collar Registration Portal';

  direction = 'ltr'; // default

  constructor(private translate: TranslateService) {
    const browserLang = this.translate.getBrowserCultureLang() || this.translate.getBrowserLang() || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(browserLang.match(/^(en|es|de|ar|fr|hu|mk|ms|pl|ro|sr|th|vi)(-|$)/i) ? browserLang : 'en');

    this.translate.onLangChange.subscribe((event) => {
      this.direction = event.lang.startsWith('ar') ? 'rtl' : 'ltr';
      document.documentElement.dir = this.direction;
    });

  }
}
